export default __webpack_public_path__ + "static/media/wedding-ring.189b09a7.png";